import { joinInfoMeta } from './joinMetaInfo.js';
import { parseData } from './parseData';
import { setFIDSpectrumData } from './setFIDSpectrumData';
import { setXYSpectrumData } from './setXYSpectrumData';

export async function convert1D(files, options) {
  const result = await parseData(files.procs, options);
  const acqus = await parseData(files.acqus, options);
  joinInfoMeta(result, acqus);

  if (files['1r'] || files['1i']) {
    await setXYSpectrumData(
      {
        re: files['1r'],
        im: files['1i'],
      },
      result,
    );
  } else if (files.fid) {
    await setFIDSpectrumData(files.fid, result);
  }

  return result;
}
